/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Include_FsInputs */



/**
* | output |
* | --- |
* | "Include FS" |
*
* @param {Subtitle_Export_Include_FsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_include_fs = /** @type {((inputs?: Subtitle_Export_Include_FsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Include_FsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inclure FS")
	if (locale === "de") return /** @type {LocalizedString} */ ("FS einschließen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Includi FS")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Включить FS")
	if (locale === "es") return /** @type {LocalizedString} */ ("Incluir FS")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("包括 FS")
	if (locale === "ja") return /** @type {LocalizedString} */ ("FSを含める")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एफएस शामिल करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Incluir FS")
	return /** @type {LocalizedString} */ ("Include FS")
});